module.exports = __webpack_public_path__ + "static/img/pelvis3_1.9733a1d8.png";